import { useEffect, type ReactNode } from 'react';

export function SellerReportDrawer({ open, title, onClose, children }: {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
}) {
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (event: KeyboardEvent) => { if (event.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  if (!open) return null;
  return <div className="fixed inset-0 z-[70]">
    <button type="button" aria-label="Close drawer backdrop" onClick={onClose} className="absolute inset-0 h-full w-full bg-slate-950/35" />
    <aside role="dialog" aria-modal="true" aria-label={title} className="absolute inset-y-0 right-0 flex h-dvh w-full max-w-full flex-col border-l border-slate-200 bg-white shadow-2xl md:w-[700px]">
      <header className="flex min-h-16 shrink-0 items-center justify-between gap-4 border-b border-slate-200 px-5 py-4">
        <h2 className="min-w-0 break-words text-lg font-semibold text-slate-950">{title}</h2>
        <button type="button" aria-label="Close drawer" onClick={onClose} className="flex h-11 w-11 shrink-0 items-center justify-center rounded border border-slate-300 text-xl text-slate-700" title="Close">×</button>
      </header>
      <div className="min-h-0 flex-1 overflow-y-auto px-5 py-6 sm:px-6">{children}</div>
    </aside>
  </div>;
}